/* Autogenerated file. Do not modify */
'use strict'
const skins = {}
 skins['wysiwyg.viewer.skins.PageGroupSkin'] = {
  "react": []
}

module.exports = skins